
document.addEventListener('DOMContentLoaded', initTimeline);

function initTimeline() { 

  const aniElements = document.querySelector('body.animation-on')
    if (aniElements)  { 
      const items = aniElements.querySelectorAll('.ani')
      items.forEach(txtElement =>{
        new TimeLineAnimation(txtElement); 
      })   
  }
 
}


class TimeLineAnimation{
  constructor(txtElement){
    this.id = txtElement;
   
    if (this.id)  this.events();    
  }
  
  events() {
    window.addEventListener('load',   ()=> this.checkBoxes()); 
    window.addEventListener('resize', () =>this.checkBoxes()); 
    window.addEventListener('scroll', ()=> this.checkBoxes());   
  }  

  checkBoxes() {      
    const triggerBottom = window.innerHeight / 5 * 4    
    const boxTop = this.id.getBoundingClientRect().top //it is getting less while scroll
  
    if(boxTop < triggerBottom) {   
      if( !this.id.classList.contains('anishow') ) this.id.classList.add('anishow');        
    } else {
      this.id.classList.remove('anishow')
    }   
  }


  run() {    
    if (this.isInViewport(this.id)) {
      if( !this.id.classList.contains('anishow')) this.id.classList.add('anishow');
    } 
    else {
      this.id.classList.remove('anishow');
    }    
  }

  isInViewport( el ) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    )
  } 
}
